import {
  FiGlobe,
  FiSmartphone,
  FiMonitor,
  FiCpu,
  FiLayers,
  FiCloud,
  FiTrendingUp,
  FiSearch,
  FiZap,
} from 'react-icons/fi';

export const services = [
  {
    slug: 'web-development',
    icon: FiGlobe,
    title: 'Web Development',
    short: 'Lightning-fast websites and web apps that look modern and convert.',
    description:
      'From single-page brochures to multi-region web apps. Built on React, Next.js and Node — SEO-ready, accessible, and easy for your team to update.',
    bullets: [
      'Marketing & business websites',
      'Custom web applications',
      'Headless CMS & blog systems',
      'Performance & Core Web Vitals tuning',
    ],
    tags: ['React', 'Next.js', 'Node.js'],
    accent: '#6366f1',
  },
  {
    slug: 'mobile-apps',
    icon: FiSmartphone,
    title: 'Mobile Apps',
    short: 'iOS + Android apps from one React Native codebase.',
    description:
      'Cross-platform mobile experiences that feel native. We ship to App Store and Play Store with CI/CD, push notifications, and analytics already wired in.',
    bullets: [
      'React Native + Expo apps',
      'Push notifications & deep links',
      'In-app payments (Razorpay, Stripe)',
      'App Store & Play Store releases',
    ],
    tags: ['React Native', 'Expo', 'Firebase'],
    accent: '#06b6d4',
  },
  {
    slug: 'desktop-software',
    icon: FiMonitor,
    title: 'Desktop Software',
    short: 'Windows, macOS and Linux apps with installers + auto-update.',
    description:
      'When your workflow lives offline or needs OS-level access, we build first-class desktop software with Electron and Tauri.',
    bullets: [
      'Cross-platform Electron / Tauri apps',
      'Auto-update & code signing',
      'Offline-first data sync',
      'Hardware & device integrations',
    ],
    tags: ['Electron', 'Tauri', 'Rust'],
    accent: '#10b981',
  },
  {
    slug: 'iot-solutions',
    icon: FiCpu,
    title: 'IoT Solutions',
    short: 'Connected devices, dashboards and alerts — end-to-end.',
    description:
      'Sensors, gateways, MQTT brokers and live dashboards. We have shipped IoT platforms for cold-chain, smart energy, retail footfall and predictive maintenance.',
    bullets: [
      'Sensor + gateway selection',
      'MQTT / HTTP telemetry pipelines',
      'Real-time dashboards & alerts',
      'OTA firmware updates',
    ],
    tags: ['ESP32', 'MQTT', 'Node-RED'],
    accent: '#f59e0b',
  },
  {
    slug: 'digital-marketing',
    icon: FiTrendingUp,
    title: 'Digital Marketing',
    short: 'Performance marketing + content that compounds.',
    description:
      'Google Ads, Meta Ads, WhatsApp nurture flows, and a content calendar that builds organic traffic month over month — with transparent reporting.',
    bullets: [
      'Google Ads & Meta Ads management',
      'WhatsApp Business automation',
      'Email & lifecycle marketing',
      'Monthly KPI dashboards',
    ],
    tags: ['Google Ads', 'Meta', 'WhatsApp'],
    accent: '#ef4444',
  },
  {
    slug: 'seo-content',
    icon: FiSearch,
    title: 'SEO &amp; Content',
    short: 'Rank on Google for the queries your customers actually search.',
    description:
      'Technical SEO audits, on-page optimisation, link building and a content engine that publishes weekly. Geared for Indian SERPs and local intent.',
    bullets: [
      'Technical SEO audits',
      'On-page + schema optimisation',
      'Local SEO + Google Business',
      'Content & link building',
    ],
    tags: ['SEO', 'GSC', 'Schema'],
    accent: '#8b5cf6',
  },
  {
    slug: 'product-design',
    icon: FiLayers,
    title: 'Product Design',
    short: 'Interfaces that feel intentional and trustworthy.',
    description:
      'UX research, interaction design, and design systems — built to ship, not to sit in Figma. We work directly with engineering on every screen.',
    bullets: [
      'UX research & user flows',
      'Design systems in Figma',
      'Prototyping & usability testing',
      'Brand & visual identity',
    ],
    tags: ['Figma', 'UX', 'Design Systems'],
    accent: '#ec4899',
  },
  {
    slug: 'cloud-backend',
    icon: FiCloud,
    title: 'Cloud &amp; Backend',
    short: 'APIs, databases, auth and infra that just work.',
    description:
      'Production-ready backends with proper observability. AWS, Vercel, Render — we pick the boring tech that lets your team sleep at night.',
    bullets: [
      'REST &amp; GraphQL APIs',
      'PostgreSQL / MongoDB',
      'Auth, payments &amp; webhooks',
      'CI/CD &amp; monitoring',
    ],
    tags: ['AWS', 'Postgres', 'Docker'],
    accent: '#0ea5e9',
  },
  {
    slug: 'ai-integration',
    icon: FiZap,
    title: 'AI Integration',
    short: 'LLMs, RAG and intelligent automation for your product.',
    description:
      'Bring chat, search, summarisation and decision-support into your product with the right model, the right guardrails, and a sensible budget.',
    bullets: [
      'Chatbots &amp; assistants',
      'RAG over your documents',
      'Smart search &amp; summarisation',
      'Workflow automation',
    ],
    tags: ['Claude', 'OpenAI', 'RAG'],
    accent: '#22c55e',
  },
];

export const findService = (slug) => services.find((s) => s.slug === slug);
